import type { ReactNode } from "react";
import { FormattedMessage } from "react-intl";

type Props = {
  values: string[] | null;
};

const UserPermissionArrayValueLabel = ({ values }: Props) => {
  let formattedValue: ReactNode;

  if (!values) {
    formattedValue = <FormattedMessage id="all" />;
  } else if (values.length === 0) {
    formattedValue = <FormattedMessage id="NONE" />;
  } else {
    formattedValue = values.join(", ");
  }

  return <span>{formattedValue}</span>;
};

export default UserPermissionArrayValueLabel;
